export default "__VITE_ASSET__BfIuXPis__"